// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__3jQgs","spinnerImage":"LoadingSpinner_spinnerImage__1bhCT"};